import { useQuery } from '@tanstack/react-query';

import { GetAgentsParams, getAgentsWithPagination } from '../services/unifiedAgents';

type UseGetAgentsWithPaginationParams = GetAgentsParams & { enabled?: boolean };

export function useGetAgentsWithPagination(params: UseGetAgentsWithPaginationParams) {
  const {
    instanceId,
    page = 1,
    pageSize = 20,
    searchQuery = '',
    agentType,
    status,
    sort,
    order,
    createdBy,
    updatedBy,
    visibility,
    enabled = true,
  } = params;

  const queryConfig = getAgentsWithPagination({
    instanceId,
    page,
    pageSize,
    searchQuery,
    agentType,
    status,
    sort,
    order,
    createdBy,
    updatedBy,
    visibility,
  });

  return useQuery({
    queryKey: queryConfig.key,
    queryFn: queryConfig.queryFn,
    enabled: !!instanceId && enabled,
  });
}
